export default "__VITE_ASSET__Da3QA9o2__"